import { buttonVariants } from '@/components/shadcn/button'
import { useSessionStorage } from '@/hooks'
import { ProjectDetailsLayout, ProjectLinkedWorkspacesPanel, ProjectWorkspacesSection } from '../ProjectDetailsLayout'
import { filterProjectWorkspaces } from '../projectWorkspaceUtils'
import { getProjectOrganisationId, UserLinkedProject } from '../useUserLinkedProjects'
import { isSuperUser } from '@/util'
import { Link } from 'react-router'
import { cn } from '@/lib/utils'
import { IconV2ArrowRightOutline } from '@icons/IconV2ArrowRightOutline'

export function ProjectsDetailPanel({
  project,
  searchString,
  canEditProjectLeaders,
}: {
  project: UserLinkedProject
  searchString: string
  canEditProjectLeaders: boolean
}) {
  const {
    projectId,
    name,
    workspaceCount,
    isFrozen,
    frequency,
    administrators,
    leaders,
    members,
    canCreateWorkspace,
    canEditProjectAdmins,
    canEditMembers,
  } = project
  const organisationId = getProjectOrganisationId(project)
  const [roles] = useSessionStorage('roles', 0)
  const search = searchString.trim().toLowerCase()
  const filteredWorkspaces = filterProjectWorkspaces(project, search)
  const organisationProject =
    organisationId != null
      ? {
          projectId,
          name,
          isFrozen,
          workspaceCount,
          leaders,
          administrators,
        }
      : undefined

  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="flex h-14 shrink-0 items-center justify-between border-b border-border px-5">
        <h3 className="shrink-0 truncate text-xl font-bold text-foreground">{name}</h3>
        {/* <Button size="sm" className="shrink-0" asChild> */}
        <Link
          className={cn(buttonVariants({ size: 'sm', variant: 'secondary' }), 'shrink-0')}
          to={`/projects/${projectId}`}
        >
          Open project
          <IconV2ArrowRightOutline />
        </Link>
        {/* </Button> */}
      </div>
      <ProjectDetailsLayout
        className="min-h-0 flex-1 border-0 bg-background"
        projectId={projectId}
        leaders={leaders}
        administrators={administrators}
        members={members}
        frequency={frequency}
        organisationId={organisationId}
        selectedProject={organisationProject}
        canEditProjectLeaders={canEditProjectLeaders}
        canEditProjectAdmins={canEditProjectAdmins}
        canEditMembers={canEditMembers}
        showProjectQuickLinks
        showDmpChat={isSuperUser(roles)}
        scrollDetails
      >
        <ProjectLinkedWorkspacesPanel scrollable>
          <ProjectWorkspacesSection
            className="rounded-lg bg-background pb-3 pl-4 pt-4"
            workspaces={filteredWorkspaces}
            projectId={projectId}
            organisationId={organisationId ?? 0}
            projectName={name}
            canCreateWorkspace={canCreateWorkspace}
            canRequestWorkspace={organisationId != null}
            excludedAppIds={project.workspaces.map((w) => w.appId).filter((id) => id > 0)}
          />
        </ProjectLinkedWorkspacesPanel>
      </ProjectDetailsLayout>
    </div>
  )
}
